import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const Navigation = ({ brand = "split" }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const brandifyLinks = [
    { name: "About", path: "/brandify/about" },
    { name: "Services", path: "/brandify/services" },
    { name: "Case Studies", path: "/brandify/case-studies" },
    { name: "Process", path: "/brandify/process" },
    { name: "Contact", path: "/brandify/contact" },
  ];

  const studioLinks = [
    { name: "About", path: "/studio/about" },
    { name: "Services", path: "/studio/services" },
    { name: "Portfolio", path: "/studio/portfolio" },
    { name: "Contact", path: "/studio/contact" },
  ];

  const isBrandify = brand === "brandify" || brand === "split";
  const isStudio = brand === "studio" || brand === "split";

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className="fixed top-0 left-0 right-0 z-50 px-6 py-4"
      >
        <div className="max-w-7xl mx-auto">
          <div className="glass-effect rounded-2xl px-6 py-4 flex items-center justify-between">
            {/* Logo / Home */}
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_0e969947-7505-4128-b7ce-8f5e84eb998a/artifacts/8iav2t1x_Brandify%20white%20Transparent.png"
                alt="Brandify"
                className="h-8"
              />
              <span className="text-white text-xl">×</span>
              <img 
                src="https://customer-assets.emergentagent.com/job_0e969947-7505-4128-b7ce-8f5e84eb998a/artifacts/30gtz95k_Wake%20n%20Bake%20Studio_White.png"
                alt="Wake N' Bake Studio"
                className="h-8"
              />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-8">
              {brand === "split" && (
                <>
                  <Link
                    to="/brandify/services"
                    className="text-sm font-medium text-[#1cb5ae] hover:text-[#1aada5] transition-colors"
                    data-testid="nav-brandify-link"
                  >
                    Brandify Official
                  </Link>
                  <Link
                    to="/studio/services"
                    className="text-sm font-medium text-[#F97316] hover:text-[#FB923C] transition-colors"
                    data-testid="nav-studio-link"
                  >
                    Wake N' Bake Studio
                  </Link>
                </>
              )}

              {brand === "brandify" && (
                <>
                  {brandifyLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className="text-sm font-medium text-white hover:text-[#1cb5ae] transition-colors"
                      data-testid={`nav-${link.name.toLowerCase().replace(' ', '-')}`}
                    >
                      {link.name}
                    </Link>
                  ))}
                  <Link
                    to="/studio/services"
                    className="text-sm font-medium text-[#F97316] hover:text-[#FB923C] transition-colors"
                  >
                    Visit Studio →
                  </Link>
                </>
              )}

              {brand === "studio" && (
                <>
                  {studioLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className="text-sm font-medium text-white hover:text-[#F97316] transition-colors"
                      data-testid={`nav-${link.name.toLowerCase()}`}
                    >
                      {link.name}
                    </Link>
                  ))}
                  <Link
                    to="/brandify/services"
                    className="text-sm font-medium text-[#1cb5ae] hover:text-[#1aada5] transition-colors"
                  >
                    Visit Brandify →
                  </Link>
                </>
              )}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-white"
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="fixed top-20 left-4 right-4 z-40 glass-effect rounded-2xl p-6 md:hidden"
          data-testid="mobile-menu"
        >
          <div className="flex flex-col gap-4">
            {brand === "split" && (
              <>
                <Link
                  to="/brandify/services"
                  className="text-lg font-medium text-[#1cb5ae] hover:text-[#1aada5] transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Brandify Official
                </Link>
                <Link
                  to="/studio/services"
                  className="text-lg font-medium text-[#F97316] hover:text-[#FB923C] transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Wake N' Bake Studio
                </Link>
              </>
            )}

            {brand === "brandify" &&
              brandifyLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-lg font-medium text-white hover:text-[#1cb5ae] transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}

            {brand === "studio" &&
              studioLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-lg font-medium text-white hover:text-[#F97316] transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
          </div>
        </motion.div>
      )}
    </>
  );
};

export default Navigation;